import React, { useEffect, useState } from 'react'
import TinyTag from './TinyTag';
import { BsPersonWorkspace } from "react-icons/bs"
import useOperatorStorage from '../../hooks/localStorage/useOperatorStorage';
import useWebSocketCaller from '../../hooks/useWebSocketCaller';
import './PopingTask.css'


// ------------- Static ---------------

const timeUnits = {
  s:'Second',
  m:'Minute',
  h:'Hour',
  d:'Day',
  w:'Week',
  o:'Month',
  y:'Year'
}

export const durationAsLabel = (unit, count) => {
  if (!unit || !count) {
    return '';
  }

  const timeChar = unit.toLowerCase();
  const timeUnitLabel = `${timeUnits[timeChar]}${count > 1 ? 's':''}`;
  return `${count} ${timeUnitLabel}`;
}

export default function PopingTask({popTaskData}) {
  const {sendMessage}                       = useWebSocketCaller();
  const {operator}                          = useOperatorStorage();    
  const [popTaskUpdated, setPopTaskUpdated] = useState(null);        
  
  useEffect(()=>{
    if (popTaskData) {
      setPopTaskUpdated(popTaskData);
    }
    else {
      setPopTaskUpdated(null);
    }
  }, [popTaskData]);          
    
  //
  // --- Save Task ---
  //
  const saveTask = () => {
    const taskInfo = {...popTaskUpdated};
    console.log('Saving PopTask: %s', JSON.stringify(taskInfo, null, 2));
    
    sendMessage('create-team-task', {
       teamId: operator.selectedTeamId,
       owner: operator.userId,
       accountId: operator.accountId,
       title: taskInfo.subject,
       body: taskInfo.body,
       //note: taskInfo.note,
       dueUnit: taskInfo.dueUnit,
       dueCount: taskInfo.dueCount,
       tags:  taskInfo.tags
    });

    setPopTaskUpdated(null);
  }

  // ------  Render  --------

  const estTitle = durationAsLabel(popTaskUpdated?.dueUnit, popTaskUpdated?.dueCount);

  const style = `${popTaskUpdated ? 'popTask':'popTaskEmpty'}`;

  const tagsComp = popTaskUpdated?.tags?.map(tag => <TinyTag tagName={tag} key={tag}/>);

  // Push Goal: This is our Goal Task - Let's Push to Finish useWebSockets-Queue-Team /Push /Goal /use WebSocket /websockets 2d
  // A task can be defined as "Push" simply by the "Push" tag which auto-removed when the task is done.  
  return (
    <div className={style}>
      {popTaskUpdated?.dueUnit && 
        < div className='popHeader'>
          <div className='popWorkerIcon'> 
            <BsPersonWorkspace />
          </div>
          <div className='popEst'>
            {estTitle}
          </div>
        </div>
      }            

      {popTaskUpdated?.subject &&
      <div className='popSubject'>
          <div className='popTinyHeader'>Subject</div>
          <div className='popContent'>{popTaskUpdated?.subject}</div>
      </div>
      }

      {popTaskUpdated?.body &&
      <div className='popBody'>
          <div className='popTinyHeader'>Details</div>
          <div className='popContent'>{popTaskUpdated?.body}</div>
      </div>
      }

      {popTaskUpdated?.subject &&
      <div className='popCtrl'>
        {popTaskUpdated?.tags && <div className='popTags'>
          {tagsComp}
        </div>}
        <button className='popCreateButton' onClick={saveTask}>Save</button>
      </div>
      }
    </div>
  )
}